import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SectorPipe } from '@shared/pipes/sector.pipe';

import { QuestionnaireService } from '@shared/services/questionnaire.service';
import { DataGridConfig } from '@shared/components/data-grid/data-grid-config';
import { sector } from '@app/shared/models/sector';
import { AnswerSet } from '@app/shared/models/answerset';

@Component({
  selector: 'db-add-question-dialog',
  templateUrl: './answer-set-add-question-dialog.component.html',
  styleUrls: ['./answer-set-add-question-dialog.component.scss']
})
export class AnswerSetAddQuestionDialogComponent implements OnInit {
  dataGridConfig: DataGridConfig;
  tabs: string;

  questions = [];
  answersetId = '';
  filteredRowData: any[];
  selectedRowData: any[] = [];
  selectedAnswerSet: AnswerSet;
  rowSelection;
  defaultColDef;

  dropdownList: Array<sector> = [];
  selectedItems = [];
  dropdownSettings = {};

  constructor(
    private sectorPipe: SectorPipe,
    private questionnaireService: QuestionnaireService,
    public addQuestionDialogRef: MatDialogRef<AnswerSetAddQuestionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.tabs = this.data.tabs;
    this.answersetId = this.data.answersetId;

    this.initializeDropdown();
    this.configureGrid();

    this.questionnaireService.getAnswerSetData(this.answersetId).subscribe(([answerset, answersetFields]) => {
      this.selectedAnswerSet = answerset;
      this.questionnaireService.getQuestionnaireContent(answerset.questionnaireId).subscribe(([model, fields]) => {
        for (const tabs of fields.body) {
          for (const question of tabs.fields) {
            if (this.showQuestion(answerset.body.hideExpressionValue, question)) {
              question.sectorName = this.questionnaireService.getSector(question.sector);
              for (const property in model) {
                if (model.hasOwnProperty(property)) {
                  if (property.startsWith(question.id)) {
                    if (question.value === '') {
                      question.value = {};
                    }
                    question.value[property] = model[property];
                  }
                }
              }
              this.questions.push(question);
            }
          }
        }

        this.filteredRowData = this.questions;
      });
    });

  }

  showQuestion(hideExpressionValue, field): boolean {
    let visible = true;
    //"!model.hideExpressionValue.split(';').some(function(e){ if(e.length > 0) return this.field.sector.indexOf(e) >= 0 }, this) && model.hideExpressionValue.indexOf(this.field.id) < 0"

    visible = !hideExpressionValue.split(';')
      .some(function (e) {
      if (e.length > 0)
        return field.sector.indexOf(e) >= 0
        })
      && hideExpressionValue.indexOf(field.id) < 0;

    return visible;
  }
  initializeDropdown() {
    this.dropdownSettings = {
      idField: 'id',
      textField: 'sectorName'
    };

    this.getSectors();
  }

  getSectors() {
    this.questionnaireService.getSectors()
      .subscribe(result => {
        this.dropdownList = result;
      });
  }

  configureGrid() {
    this.dataGridConfig = {
      columnDefs: [
        {
          headerName: 'Question',
          field: 'templateOptions.label',
          minWidth: 200
        },
        {
          headerName: 'Sector',
          field: 'sectorName',
          minWidth: 200
        }
      ],
      defaultColDef: {
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn
      },
      rowSelection: 'multiple',
      gridCompact: true
    };
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  selectedRows($event) {
    this.selectedRowData = $event;
  }

  filterRowData($event) {
    this.filteredRowData = this.questions;
    this.filteredRowData = this.sectorPipe.transform(this.filteredRowData, $event);
  }

  resetRowDataFilter() {
    this.filteredRowData = this.questions;
  }

  AddQuestion() {
    if (this.selectedRowData) {
      for (let i = 0; i < this.selectedRowData.length; i++) {
        this.selectedAnswerSet.body['hideExpressionValue'] += this.selectedRowData[i].id + ';';
        // if (this.selectedAnswerSet.body[this.selectedRowData[i].value]) {
        // this.selectedAnswerSet.body[this.selectedRowData[i].id] = this.selectedRowData[i].value;
        const properties = this.selectedRowData[i].value;
        for (const property in properties) {
          if (properties.hasOwnProperty(property)) {
            this.selectedAnswerSet.body[property] = properties[property];
          }
        }
      }

      this.questionnaireService.saveAnswerSet(this.selectedAnswerSet.body, this.answersetId, this.selectedAnswerSet.answerSetName, false);
    }
    this.addQuestionDialogRef.close(JSON.stringify(this.selectedRowData));

  }
}
